import { useState } from "react";
import { MapPin, Plus, Trash2 } from "lucide-react";
import { useAuth } from "../auth/AuthProvider";
import { Button } from "../../shared/ui/Button";
import { Card } from "../../shared/ui/Card";
import { PageSkeleton, StatusBadge } from "../../shared/ui/Status";
import { useScheduling, useSchedulingActions } from "./useScheduling";
export function VenueManagementPanel() {
  const { session } = useAuth();
  const scheduling = useScheduling();
  const actions = useSchedulingActions();
  const [name, setName] = useState("");
  const [type, setType] = useState<"court" | "workstation">("court");
  const [notice, setNotice] = useState("");
  const [error, setError] = useState("");
  if (!session || !scheduling.data) return <PageSkeleton />;
  const venues = scheduling.data.venues.filter(
    (v) => v.active && v.storeId === session.profile.storeId,
  );
  const submit = async () => {
    if (!name.trim()) {
      setError("请填写场地或工位名称。");
      return;
    }
    setNotice("");
    setError("");
    try {
      await actions.createVenue({
        name: name.trim(),
        type,
        storeId: session.profile.storeId!,
      });
      setNotice("场地/工位已创建。");
      setName("");
    } catch (cause) {
      setError(cause instanceof Error ? cause.message : "创建失败");
    }
  };
  const remove = async (venueId: string, venueName: string) => {
    if (!window.confirm(`确认删除“${venueName}”？无历史记录会直接删除，有排课历史会安全归档并从列表隐藏。`)) return;
    setNotice("");
    setError("");
    try {
      await actions.deleteVenue(venueId);
      setNotice("场地/工位已删除；相关历史记录已安全保留。");
    } catch (cause) {
      setError(cause instanceof Error ? cause.message : "删除失败");
    }
  };
  return (
    <section className="page-stack venue-panel">
      <div className="section-divider">
        <span>排课资源</span>
        <h2>场地与工位</h2>
      </div>
      {(notice || error) && (
        <div
          className={
            error ? "inline-notice inline-notice--error" : "inline-notice"
          }
        >
          {error || notice}
        </div>
      )}
      <div className="management-grid">
        <Card className="management-card">
          <div className="card-heading">
            <Plus />
            <div>
              <span>本店资源</span>
              <h2>新增场地/工位</h2>
            </div>
          </div>
          <div className="v4-form">
            <label className="v4-field">
              <span>名称</span>
              <input
                value={name}
                onChange={(e) => setName(e.target.value)}
                placeholder="例如：网球场B"
              />
            </label>
            <label className="v4-field">
              <span>类型</span>
              <select
                value={type}
                onChange={(e) =>
                  setType(e.target.value as "court" | "workstation")
                }
              >
                <option value="court">场地</option>
                <option value="workstation">工位</option>
              </select>
            </label>
            <Button onClick={submit} disabled={actions.pending || !name.trim()}>
              <Plus size={15} />
              创建资源
            </Button>
          </div>
        </Card>
        <Card className="directory-card">
          <div className="card-heading">
            <MapPin />
            <div>
              <span>冲突校验维度</span>
              <h2>本店可用资源</h2>
            </div>
          </div>
          <div className="venue-list">
            {venues.map((v) => (
              <div key={v.id}>
                <strong>{v.name}</strong>
                <span>{v.type === "court" ? "场地" : "工位"}</span>
                <StatusBadge tone="success">启用</StatusBadge>
                <button
                  className="icon-button icon-button--danger"
                  onClick={() => remove(v.id, v.name)}
                  disabled={actions.pending}
                  aria-label={`删除${v.name}`}
                  title="删除资源"
                >
                  <Trash2 size={16} />
                </button>
              </div>
            ))}
          </div>
        </Card>
      </div>
    </section>
  );
}
